<template>
  <div class="teams">
    <div class="flex category-buttons">
      <div id="all" class="category" :class="{ active: filter == 'all' }" @click="filter = 'all'">
        All Teams
      </div>
      <div v-for="team in teams" :key="team.id" :id="team.id" class="category" :class="{ active: filter == team.id }" @click="filter = team.id">
        {{ team.title }}
      </div>
    </div>

    <div class="items flex">
      <person-card v-for="member in filteredMembers" :key="member.id" :person="member"></person-card>
    </div>
  </div>
</template>

<script>
import PersonCard from './PersonCard'

export default {
  components: {
    PersonCard,
  },

  props: {
    members: {
      type: Array,
      required: true,
    },
    teams: {
      type: Array,
      required: true,
    },
  },

  data () {
    return {
      filter: 'all',
    }
  },

  computed: {
    filteredMembers () {
      // if all, return all members
      if (this.filter == 'all') {
        return this.members
      }

      // filter by the selected team
      return this.members.filter(member => member.team.includes(this.filter))
    },
  },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/OurPeople.vue